import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { CurrencyContext } from '../config/CurrencyContext';
import Translations from '@checkout-h/translation';
import { TranslationContext } from '@checkout-c/Translations';
import { PaymentContextProvider } from '@showclix-shared/Payment/contexts/PaymentContext';
import EmailOptOutContainer from '@checkout/views/checkout/containers/EmailOptOutContainer';
import QuestionOptInContainer from '@checkout/views/checkout/containers/QuestionOptInContainer';
import TermsOfServiceContainer from "@checkout/views/checkout/containers/TermsOfServiceContainer";
import StepActionContainer from '@checkout/views/checkout/containers/StepActionContainer';
import LocalizedAddress from '@checkout/views/member/components/LocalizedAddress';
import InsuranceContainer from '@checkout/views/insurance/containers/InsuranceContainer';
import LoyaltyProgramContainer from '@checkout/views/loyalty-programs/containers/LoyaltyProgramContainer';
import { PaymentPlans } from '@checkout-v/payment-plans/components/PaymentPlans';
import { FocusTrapProvider } from '../contexts/FocusTrapContext';
import NavigationService from '@checkout/components/NavigationService';
import { MemoryRouter, Routes, Route, useNavigate } from 'react-router';
import { getListingItem } from '@checkout-b/listing/helpers/storage';
import { buildPathFromRouteName } from '@checkout-h/withRouterCompat';

class EmbeddedComponentWrapper extends React.Component {

    constructor(props) {
        super(props);
        this.t = new Translations(this.props.apiUrl);
        this.t.init('en_US', props.translations);
    }

    render() {
        return (
            <TranslationContext.Provider value={this.t}>
                <FocusTrapProvider>
                    <PaymentContextProvider value={{
                        TranslationContext,
                        LocalizedAddress,
                        StepAction: StepActionContainer,
                        LoyaltyProgram: <LoyaltyProgramContainer />,
                        Insurance: <InsuranceContainer />,
                        PaymentPlans: <PaymentPlans />,
                        OptInsOuts: (
                            <>
                              <TermsOfServiceContainer />
                              <EmailOptOutContainer />
                              <QuestionOptInContainer />
                            </>
                        ),
                    }}>
                        <CurrencyContext.Provider value={this.props.currencyConfig}>
                          <MemoryRouter>
                            <NavigationService isEmbed={true}/>
                            <Routes>
                              <Route path="*" element={<PersistEmbedRouterHydrator />} />
                            </Routes>
                            {this.props.children}
                          </MemoryRouter>
                        </CurrencyContext.Provider>
                    </PaymentContextProvider>
                </FocusTrapProvider>
            </TranslationContext.Provider>
        )
    }
}

let rehydratedEmbedRouterState = false;
function PersistEmbedRouterHydrator() {
  const navigate = useNavigate();
  const isEmbed = useSelector((s) => s.ui.isEmbed);
  const currentRouteName = useSelector((s) => s.ui.currentRouteName);
  const listing = useSelector((s) => s.ui.listingSlug);
  const token = getListingItem(listing, "token")

  useEffect(() => {
    // go back to where the router was at before the page was refreshed/reloaded
    if (isEmbed && !rehydratedEmbedRouterState) {
      rehydratedEmbedRouterState = true;
      if (currentRouteName !== 'ticketPicker') {
        const path = buildPathFromRouteName(currentRouteName, token ? { token } : {});
        navigate(path);
        return;
      }
    }
  }, []);

  return null;
}

const mapStateToProps = (state, props) => {
    return {
        currencyConfig: state.ui.currencyConfig,
    }
}

export default connect(mapStateToProps)(EmbeddedComponentWrapper);
